export const DESCRIPTION_TOOLTIP_POPPER_PROPS = {
  disablePortal: false,
  popperOptions: { strategy: 'fixed' },
  style: { zIndex: 1301 },
};
